var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container feedback template-bg-gray",
      class: { "my-position-relative": _vm.isStatus }
    },
    [
      _vm.isStatus
        ? _c(
            "md-card",
            {
              staticClass:
                "request-status loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "md-card-content",
                { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main" },
                [
                  _c(
                    "div",
                    { staticClass: "card form-wrapper text-center p-20" },
                    [
                      _c("h4", {
                        staticClass: "template-custom-title",
                        domProps: { innerHTML: _vm._s(_vm.statusMsg) }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStatus
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card form-wrapper",
                        class: { thankupageplr88: _vm.success }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "feedback_container feedback_newupdate"
                          },
                          [
                            _c("div", { staticClass: "community-logo" }, [
                              _c("img", {
                                staticClass: "top-logo custom-logo",
                                attrs: {
                                  src: _vm.logoURL,
                                  alt:
                                    "Community Logo of " +
                                    _vm.community.content.parameter4
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "common-space-from-logo my-text-center",
                                class: {
                                  "email-actionpage-tmsg plr10": !_vm.success
                                }
                              },
                              [
                                _c(
                                  "h1",
                                  {
                                    staticClass: "template-title",
                                    attrs: {
                                      id: "main-header",
                                      "aria-live": "polite"
                                    }
                                  },
                                  [_vm._v("Thank you!")]
                                ),
                                _vm._v(" "),
                                !_vm.success
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "custom-content my-text-center",
                                        attrs: { "aria-live": "polite" }
                                      },
                                      [
                                        _vm._v(
                                          "We really appreciate your feedback!"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.success,
                                    expression: "!success"
                                  }
                                ],
                                staticClass: "template-form",
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.updateFeedback()
                                  }
                                }
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2",
                                        class: [
                                          {
                                            "b-error": _vm.errors.has("comment")
                                          },
                                          "form-group",
                                          "pd-remove",
                                          "unsubscribe-height"
                                        ]
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "char-counter-input" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: {
                                                  id: "char-counter-feedback",
                                                  "aria-live": "polite"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.remainingCount) +
                                                    " / " +
                                                    _vm._s(_vm.max) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [_vm._v(" character count ")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "required-symbol"
                                              },
                                              [_vm._v(" *")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.comment,
                                              expression: "comment"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required|max:500",
                                              expression: "'required|max:500'"
                                            }
                                          ],
                                          staticClass:
                                            "form-control placeholder-bold",
                                          class: {
                                            "request-form-error-border": _vm.errors.has(
                                              "comment"
                                            )
                                          },
                                          attrs: {
                                            "aria-label":
                                              "Character count available for this textarea",
                                            id: "comment",
                                            name: "comment",
                                            rows: "10",
                                            placeholder: _vm.commentPlaceholder,
                                            maxlength: _vm.max,
                                            "aria-required": "true"
                                          },
                                          domProps: { value: _vm.comment },
                                          on: {
                                            blur: _vm.handleBlur,
                                            focus: _vm.handleFocus,
                                            keyup: _vm.countdown,
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.comment =
                                                  $event.target.value
                                              },
                                              function(e) {
                                                return (_vm.comment = _vm.sanitizeInput(
                                                  e.target.value
                                                ))
                                              }
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group pd-remove unsubscribe-btn mb-0-custom"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "char-counter template-subject-counter",
                                                class: {
                                                  "char-count-error":
                                                    _vm.exceedsMaxCount
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.remainingCount) +
                                                    "  / 500"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("comment")
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.errors.first("comment")) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.community.content.testimonialConsent
                                  ? _c("div", { staticClass: "row mlr0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group disclaimer"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "template-checkbox pt-0"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.testimonialConsent,
                                                    expression:
                                                      "testimonialConsent"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  name: "testimonialConsent",
                                                  id: "testimonialConsent"
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.testimonialConsent
                                                  )
                                                    ? _vm._i(
                                                        _vm.testimonialConsent,
                                                        null
                                                      ) > -1
                                                    : _vm.testimonialConsent
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$a =
                                                        _vm.testimonialConsent,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.testimonialConsent = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.testimonialConsent = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.testimonialConsent = $$c
                                                    }
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.community.content
                                                      .testimonialConsentMessage
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 text-right" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group pd-remove unsubscribe-btn"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn_info template-review-submit template-button template-button-width",
                                            style: _vm.reviewBtn,
                                            attrs: {
                                              type: "submit",
                                              name: "helpAction"
                                            }
                                          },
                                          [_vm._v("Submit")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.success,
                                    expression: "!success"
                                  }
                                ],
                                staticClass: "m-top-34"
                              },
                              [
                                _c("div", { staticClass: "row my" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "text-center email-request-title"
                                      },
                                      [
                                        _vm._v(
                                          "FYI, here's the " +
                                            _vm._s(_vm.feedback)
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.feedback === "request"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "email-request-review" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "template-request-review"
                                            },
                                            [
                                              _vm.createdByMember.first &&
                                              _vm.createdByMember.last
                                                ? _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        id: "feedback-name"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.createdByMember
                                                            .first +
                                                            " " +
                                                            _vm.createdByMember
                                                              .last
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _vm.$lodash.has(
                                                _vm.createdByMember.emails,
                                                0
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        id: "feedback-email"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.createdByMember
                                                            .emails[0]
                                                        ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("br"),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  attrs: { id: "feedback-name" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.ask.subject)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "font-color" },
                                                [_vm._v(_vm._s(_vm.askDetail))]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.giveID && _vm.feedback === "response"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "email-request-review" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "template-request-review"
                                            },
                                            [
                                              _vm.advisorDetails.first &&
                                              _vm.advisorDetails.last
                                                ? _c("h2", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.advisorDetails
                                                          .first +
                                                          " " +
                                                          _vm.advisorDetails
                                                            .last
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.$lodash.has(
                                                _vm.advisorDetails.emails,
                                                0
                                              )
                                                ? _c("h5", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.advisorDetails
                                                          .emails[0]
                                                      )
                                                    )
                                                  ])
                                                : _vm.givesEmail
                                                ? _c("h5", [
                                                    _vm._v(
                                                      _vm._s(_vm.givesEmail)
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("h6", [
                                                _vm._v(_vm._s(_vm.giveDate))
                                              ]),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass: "font-color",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.giveText
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-inline text-center footer-links" },
                      [
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.landingPageURL &&
                          _vm.community.content.landingPageURL.length
                            ? _c(
                                "a",
                                {
                                  staticClass: "links",
                                  attrs: {
                                    href: _vm.community.content.landingPageURL,
                                    target: "_blank",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Learn More")]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:void(0)",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Learn More")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.termsConditionsURL &&
                          _vm.community.content.termsConditionsURL.length
                            ? _c(
                                "a",
                                {
                                  staticClass: "links",
                                  attrs: {
                                    href:
                                      _vm.community.content.termsConditionsURL,
                                    target: "_blank",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Terms Of Use")]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:void(0)",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Terms Of Use")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.unsubscribePageURL &&
                          _vm.community.content.unsubscribePageURL.length
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    tabindex: "0",
                                    href:
                                      _vm.community.content.unsubscribePageURL,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Opt Out")]
                              )
                            : _c(
                                "a",
                                { attrs: { href: "javascript:void(0)" } },
                                [_vm._v("Opt Out")]
                              )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "unsubscribe-community-logo" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              (_vm.community.content &&
                                _vm.community.content.landingPageURL) ||
                              "https://www.protopia.co",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.footerLogoURL,
                              alt:
                                "Community Logo of " +
                                _vm.community.content.parameter4
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Protopia - Visit our site")
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "required-note template-label",
        attrs: { id: "required-note" }
      },
      [
        _vm._v("\n                  Fields marked with an asterisk ("),
        _c("span", { staticClass: "required-symbol" }, [_vm._v("*")]),
        _vm._v(") are required.\n                ")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0721c246", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0721c246","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFeedback.vue
// module id = null
// module chunks = 